export const EMPTY_SCHEDULE_PARTICIPANT_FILTERS = Object.freeze({
    query: '',
    sex: '',
    payStatus: '',
    payType: '',
    cancelStatus: '',
});

const searchableParticipantValues = (participant) => [participant.id, participant.name, participant.nick_name, participant.phone_no, participant.admin_memo];

export const filterScheduleParticipants = (participants, filters = EMPTY_SCHEDULE_PARTICIPANT_FILTERS) => {
    if (!Array.isArray(participants)) return [];

    const query = String(filters.query || '')
        .trim()
        .toLocaleLowerCase('ko-KR');
    return participants.filter((participant) => {
        if (
            query &&
            !searchableParticipantValues(participant).some((value) =>
                String(value ?? '')
                    .toLocaleLowerCase('ko-KR')
                    .includes(query),
            )
        )
            return false;
        if (filters.sex !== '' && String(participant.sex ?? '') !== String(filters.sex)) return false;
        if (filters.payStatus !== '' && String(participant.pay_status_number ?? '') !== String(filters.payStatus)) return false;
        if (filters.payType !== '' && String(participant.pay_type_number ?? '') !== String(filters.payType)) return false;
        if (filters.cancelStatus === 'cancelled' && Number(participant.pay_status_number) !== 8) return false;
        if (filters.cancelStatus === 'active' && Number(participant.pay_status_number) === 8) return false;
        return true;
    });
};

export const buildScheduleParticipantOptions = (participants, valueKey, labelKey) => {
    if (!Array.isArray(participants)) return [];

    const options = new Map();
    participants.forEach((participant) => {
        const value = participant[valueKey];
        if (value === null || value === undefined || value === '') return;
        const label = participant[labelKey] ?? value;
        options.set(String(value), String(label));
    });
    return [...options.entries()].map(([value, label]) => ({ value, label })).sort((a, b) => a.label.localeCompare(b.label, 'ko-KR'));
};

const sexText = (sex) => {
    if (String(sex) === '1') return '남자';
    if (String(sex) === '2') return '여자';
    return '정보없음';
};

const cancelText = (participant) => (Number(participant.pay_status_number) === 8 ? '참여 취소' : '정상');

export const escapeSpreadsheetFormula = (value) => {
    if (typeof value !== 'string') return value ?? '';
    return /^\s*[=+\-@]/.test(value) ? `'${value}` : value;
};

export const SCHEDULE_PARTICIPANT_EXCEL_HEADERS = ['ID', '회원명', '닉네임', '성별', '생년월일', '휴대폰번호', '결제 상태', '결제 방법', '관리자 메모', '취소 여부'];

export const scheduleParticipantExcelRows = (participants) =>
    (Array.isArray(participants) ? participants : []).map((participant) =>
        [
            participant.id,
            participant.name,
            participant.nick_name,
            sexText(participant.sex),
            participant.birthday,
            participant.phone_no,
            participant.pay_status,
            participant.pay_type,
            participant.admin_memo,
            cancelText(participant),
        ].map(escapeSpreadsheetFormula),
    );
